export function operationSettlement(operation) {
    if (operation.purpose === 'direct_token_purchase') {
        if (!operation.purchase || operation.destinationAsset !== 'OUTCOME')
            throw new Error('onramp_purchase_binding_missing');
        return {
            provider_asset_code: operation.purchase.providerAssetCode,
            decimals: operation.purchase.decimals,
            caip19: operation.purchase.caip19,
        };
    }
    if (operation.destinationAsset === 'OUTCOME')
        throw new Error('onramp_purchase_binding_missing');
    return fundingSettlement(operation.destinationAsset);
}
/** The server selects the asset; persisted operations retain it across config changes. */
export function fundingSettlement(asset) {
    return { provider_asset_code: asset, decimals: asset === 'SOL' ? 9 : 6 };
}
